import {ReactComponent as Icon} from "./cartIcon.svg"

type StopwatchIconProps = {
	className?: string;
};

const CartIcon: React.FunctionComponent<StopwatchIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default CartIcon;